import axios from "axios";

import apiConstants from "Shared/Constants/apiConstants";
import configureApi from "Shared/Utils/configureApi";

const API = configureApi(
  axios.create({
    baseURL: apiConstants.BASE_API_URL,
    timeout: 150000,
    headers: {
      "Content-Type": "application/json",
      X_VEHICLE_TYPE: apiConstants.X_VEHICLE_TYPE,
      X_COUNTRY: apiConstants.X_COUNTRY
    }
  })
);

const API_1 = configureApi(
  axios.create({
    baseURL: apiConstants.BASE_API_URL,
    timeout: 150000,
    headers: {
      X_VEHICLE_TYPE: apiConstants.X_VEHICLE_TYPE,
      X_COUNTRY: apiConstants.X_COUNTRY
    },
    responseType: "blob"
  })
);

const WORKSHOP_API = configureApi(
  axios.create({
    baseURL: apiConstants.WORKSHOP_API_URL,
    timeout: 150000,
    headers: {
      "Content-Type": "application/json",
      X_VEHICLE_TYPE: apiConstants.X_VEHICLE_TYPE,
      X_COUNTRY: apiConstants.X_COUNTRY
    }
  }),
  true
);

const REFURB_API = configureApi(
  axios.create({
    baseURL: apiConstants.REFURB_SERVICES_API_URL,
    timeout: 150000,
    headers: {
      "Content-Type": "application/json",
      X_VEHICLE_TYPE: apiConstants.X_VEHICLE_TYPE,
      X_COUNTRY: apiConstants.X_COUNTRY
    }
  }),
  true
);

const UPLOAD_API = configureApi(
  axios.create({
    baseURL: apiConstants.UPLOAD_API_URL,
    timeout: 150000,
    headers: {
      "Content-Type": "application/json",
      X_VEHICLE_TYPE: apiConstants.X_VEHICLE_TYPE,
      X_COUNTRY: apiConstants.X_COUNTRY
    }
  }),
  true
);

export default API;
export { API_1, WORKSHOP_API, REFURB_API, UPLOAD_API };
